
<ng-template [ngIf]="isLoadingPraticheOda">
      <app-loading></app-loading>
</ng-template>
<div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
  <div class="flex justify-start md:justify-start">
      <span class="p-input-icon-left mr-2">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Cerca" (input)="filtraPratiche($event)" [disabled]="isLoadingPraticheOda" />
      </span>
  </div>
  <div class="flex justify-end md:justify-center">
  </div>
  <div class="flex justify-end md:justify-end">
    <button 
    pButton type="button" icon="pi pi-cloud-download"
    pTooltip="Scarica export" tooltipPosition="top"
    class="font-['Poppins'] "
    style="background-color:#ffffff; color: cadetblue; border-color: cadetblue; font-size: 13px;"
    label="Esporta"
    (click)="esportaPratiche()" [disabled]="isLoadingPraticheOda"
></button>
  </div>

</div>

<div fxFlex="95%" class="mt-2">
  <p-table #praticheDT styleClass="p-datatable-striped" class="pratiche-oda-table" [value]="pratiche" dataKey="id" 
  [loading]="isLoadingPraticheOda"
    [filterDelay]="0" [globalFilterFields]="['cui']"
  >

  <ng-template pTemplate="header" >
      <tr >
        <th  style="font-size: 14px;">
          CUI
        </th>
          <th class="text-center" style="font-size: 14px;">
          FASE I
          </th>
          <th class="text-center" style="font-size: 14px;">
            FASE II
          </th>
          <th class="text-center" style="font-size: 13px;">
            OPERE EXTRA
          </th>
          <th class="text-center" style="font-size: 14px;">
            FASE III
          </th>
          <th class="text-center" style="font-size: 14px;">
            KO
          </th>
         
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td> <span class="text-uppercase font-bold" style="font-weight: 500; "> {{row.cui}}</span> </td>
      <td class="text-center"> 
        <span class="text-uppercase" style="font-weight: 500; ">{{checkImportoPraticaFase1(row) | formattaNumero}}</span> 
      </td>
      <td class="text-center"> 
        <span class="text-uppercase" style="font-weight: 500; ">{{checkImportoPraticaFase2(row) | formattaNumero}}</span> 
      </td>
      <td class="text-center"> 
        <span class="text-uppercase" style="font-weight: 500; ">{{checkImportoPraticaOpereExtra(row) | formattaNumero}}</span> 
      </td>
      <td class="text-center"> 
        <span class="text-uppercase" style="font-weight: 500; ">{{checkImportoPraticaFase3(row) | formattaNumero}}</span> 
      </td>
      <td class="text-center"> <span class="text-uppercase" style="font-weight: 500; ">{{checkImportoPraticaKO(row) | formattaNumero}}</span> </td>
     
    
    </tr>
  </ng-template>
  <ng-template pTemplate="footer">
    <tr >
        <td colspan="1" class="text-right" style="font-weight: 600; font-weight: bold;">TOTALI:</td>
         <td class="text-center" style="font-weight: 500; font-weight: bold;">{{importoTotaleFase1 | formattaNumero}} €</td>
         <td class="text-center" style="font-weight: 500; font-weight: bold;">{{importoTotaleFase2 | formattaNumero}} €</td>
         <td class="text-center" style="font-weight: 500; font-weight: bold;">{{importoTotaleOpereExtra | formattaNumero}} €</td>
         <td class="text-center" style="font-weight: 500; font-weight: bold;">{{importoTotaleFase3 | formattaNumero}} €</td>
         <td class="text-center" style="font-weight: 500; font-weight: bold;">{{importoTotaleKO | formattaNumero}} €</td>

    </tr>
  </ng-template>
  
  </p-table>
   
  <div class="mt-auto border-top-1 surface-border" style="text-align: center;">
    <button
      pButton
      pRipple
      icon="pi pi-times"
      (click)="dialogRef.close(true)"
      label="CHIUDI"
      class="p-button-outlined w-6 mt-3"
    ></button>
  </div>
    
  <div>
    